import { login, logout } from '@/api/user' //, getInfo
import { getToken, getRoles, removeRoles, removePermission, setRoleId, setNickname, setAvatar, removeAllCookie, setToken, setRoles, setAllRoles, setTopNavs, setTopdefaultCur, setDefaultCur, setPermission, setAllPermission, setRouterArr, setDefaultPage, removeDefaultPage } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import Layout from '@/layout'
// const _import = require('@/router/_import_' + process.env.NODE_ENV) // 获取组件的方法
// import { _import } from `@/router/_import_${process.env.NODE_ENV}` // 获取组件的方法

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: getRoles(),
  permission: [],
  role_id: null,
  defaultPage: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSION: (state, permission) => {
    state.permission = permission
  },
  SET_ROLE_ID: (state, role_id) => {
    state.role_id = role_id
  },
  SET_DEFAULT_PAGE: (state, defaultPage) => {
    state.defaultPage = defaultPage
  }
}

/** 将Permission转成router格式 */
export function transRouteData(routes) {
  const router = []
  // 侧边一级菜单循环
  routes.forEach((ite, ind) => {
    router[ind] = {
      path: ite.route,
      component: Layout,
      redirect: 'noRedirect', // ite.child[0].route,
      name: ite.alias,
      hidden: ite.status == 1,
      id: ite.id,
      meta: {
        title: ite.name,
        icon: ite.icon
      },
      children: []
    }
    // 二级菜单循环
    ite.child.forEach((_ite, _ind) => {
      router[ind].children[_ind] = {
        path: _ite.route,
        component: (resolve) => require([`@/views${_ite.route}`], resolve),
        name: _ite.alias,
        hidden: _ite.status == 1,
        id: _ite.id,
        meta: {
          title: _ite.name,
          roles: [`${_ite.alias}`]
        }
      }
      // 按钮权限循环
      _ite.child.forEach((_it, _in) => {
        router[ind].children[_ind].meta.roles[_in + 1] = _it.alias
      })
    })
  })
  return router
}
const actions = {
  // user login
  login({ commit, dispatch }, userInfo) {
    const { name, password, code } = userInfo
    return new Promise((resolve, reject) => {
      login({ name: name, password: password, code: code }).then(async response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        // 默认页面
        var defaultCur = 0
        var defaultPath = ''
        var order_management_index = null
        // 顶层分类循环
        const myPermission = []
        data.permission.forEach((item, index) => {
          myPermission[index] = {
            alias: item.alias,
            name: item.name,
            id: item.id,
            router: item.child
          }
          if (data.default_page && data.default_page.alias == item.alias) {
            // console.log('有默认配置')
            defaultCur = index
            defaultPath = data.default_page.child.child.route
          }
          if (item.alias == 'order_management') {
            order_management_index = index
          }
        })

        if (!data.default_page) {
          // 分类中含有"订单管理"时,默认第一选项为"订单管理"
          if (order_management_index) {
            // console.log('无默认页面,有订单管理')
            // console.log(myPermission, myPermission[order_management_index].router, order_management_index, 7)
            defaultPath = myPermission[order_management_index].router[0].child[0].route
          } else {
            // console.log('无默认页面,无订单管理')
            defaultPath = myPermission[defaultCur].router[0].child[0].route
          }
        }

        commit('SET_PERMISSION', myPermission)
        setAllPermission(myPermission)

        commit('SET_ROLE_ID', data.role_id) // 角色Id
        setRoleId(data.role_id)
        commit('SET_NAME', data.nickname) // 角色昵称
        setNickname(data.nickname)
        commit('SET_DEFAULT_PAGE', data.default_page) // 默认页面
        setDefaultPage(data.default_page)
        // 头像
        let avatar = data.avatar ? process.env.VUE_APP_BASE_API + data.avatar : ''
        commit('SET_AVATAR', avatar)
        setAvatar(avatar)
        // end 头像

        // 生成新路由
        const accessRoutes = transRouteData(myPermission[defaultCur].router)
        const newAccessRoutes = await dispatch('permission/autoGenerateRoutes', accessRoutes, { root: true })
        router.addRoutes(newAccessRoutes)
        setRouterArr(newAccessRoutes)
        dispatch('tagsView/delAllViews', null, { root: true })

        var defaultRoles = [data.permission[defaultCur].alias]
        data.permission[defaultCur].child.forEach((item, index) => {
          defaultRoles.push(item.alias)
          item.child.forEach(item2 => {
            defaultRoles.push(item2.alias)
          })
        })
        commit('SET_ROLES', defaultRoles)
        setToken(data.token)
        setRoles(defaultRoles)
        /** 设置默认TopNav cur */
        setDefaultCur(defaultCur)
        /** end 设置默认TopNav cur */

        /** 设置头部导航 */
        var navList = []
        /** 设置权限集(角色) */
        var allRoles = []
        var allPermission = {} // 角色对应的权限集

        data.permission.forEach((item, index) => {
          navList[index] = {
            alias: item.alias,
            current: index == defaultCur,
            name: item.name,
            hidden: item.status == 1
          }
          allRoles[index] = [item.alias]
          item.child.forEach(item2 => {
            allRoles[index].push(item2.alias)
            item2.child.forEach(item3 => {
              allRoles[index].push(item3.alias)
              allPermission[`${item3.alias}`] = []
              item3.child.forEach(item4 => {
                allPermission[`${item3.alias}`].push(item4.alias)
              })
            })
          })
        })
        setTopdefaultCur(navList[0].alias)
        setTopNavs(navList)
        setAllRoles(allRoles)
        setPermission(allPermission)
        // commit('SET_BTNPER', allPermission)
        /** end 权限集(角色) */

        // 如果系统管理里仅仅包含系统管理-个人设置,则不显示系统管理模块
        allRoles.forEach((item, index) => {
          if (item[0] === 'system_management') {
            if (item.length <= 3) {
              // ["system_management", "system_management", "personal_setting"]
              navList.splice(index, 1)
              setTopNavs(navList)
            }
          }
        })
        resolve(defaultPath)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user info
  getInfo({ commit }, data) {
    commit('SET_ROLE_ID', data.roleId)
    commit('SET_NAME', data.name)
    commit('SET_AVATAR', data.avatar)
  },
  // change router

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removePermission()
        removeDefaultPage()
        removeAllCookie()
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeRoles()
      resolve()
    })
  },

  // dynamically modify permissions
  // changeRoles({ commit, dispatch }, role) {
  //   return new Promise(async resolve => {
  //     const token = role + '-token'

  //     commit('SET_TOKEN', token)
  //     setToken(token)

  //     const { roles } = await dispatch('getInfo')

  //     resetRouter()

  //     // generate accessible routes map based on roles
  //     const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

  //     // dynamically add accessible routes
  //     router.addRoutes(accessRoutes)
  changeRoles({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      // const token = role + '-token'

      // commit('SET_TOKEN', token)
      // setToken(token)

      // let role = getRoles()
      // var roles = JSON.parse(getRoles())
      commit('SET_ROLES', role)
      resetRouter()
      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', role, { root: true })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
